// extracted by mini-css-extract-plugin
export default {"main":"AboutUs_main__uWdSb","shadow1":"AboutUs_shadow1__NsEaB"};